import {IsoDate} from "../../pseudo-types/DateTypes";
import {IHttpService} from "angular";
import {AccountPerformanceSummary} from "../models/AccountPerformanceSummary";

export class AccountPerformanceService {

    public static id = "accountPerformanceService";

    /** @ngInject */
    constructor(private $http: IHttpService) {
    }

    public async accountSummary(portfolioId: number): Promise<AccountPerformanceSummary> {
        const url = `/tradefloor/api/trade/${portfolioId}`;
        const response = await this.$http.get<AccountPerformanceSummary>(url);
        return response.data!;
    }

    public calculateExportLink(portfolioId: number, fromDate: IsoDate, toDate: IsoDate) {
        // TODO update the server to send back equity and options always
        // Also return the type of transaction it is
        return `/tradefloor/api/trade/${portfolioId}/csv?fromDate=${fromDate}&toDate=${toDate}`;
    }
}
